export const REDUCER_NAME = 'info-table'



// WEBPACK FOOTER //
// ./src/modules/foil/state/overview/info-table/const.js